import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import API from '../../../services/API'
import { GlobalContext } from '../../../App'
import {
  Alert,
  Avatar,
  AvatarGroup,
  Box,
  Button,
  LinearProgress,
  Paper,
  Tooltip,
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import AddCircleOutline from '@mui/icons-material/AddCircleOutlined'
import { useNavigate } from 'react-router-dom'
import CustomDataGrid from '../../../components/DataGrid/CustomDataGrid'

const Meetings = () => {
  const [loading, setLoading] = useState(true)
  const [meetings, setMeetings] = useState([])
  const { setToast } = useContext(GlobalContext)

  const getMeetings = () => {
    API.get(`/governance/meetings?skip=${meetings.length}`)
      .then((res) => {
        if (res.status === 200) {
          setMeetings(res.data)
        }
      })
      .catch((e) =>
        setToast({ message: 'Unable to get Meetings', severity: 'error' }),
      )
      .finally(() => setLoading(false))
  }

  useEffect(() => getMeetings(), [])
  const navigate = useNavigate()

  return (
    <Stack gap={1} padding={1}>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        justifyContent="space-between"
      >
        <Typography variant="title2">Meetings</Typography>
        <Button
          size="small"
          onClick={() => navigate('/meetings/new')}
          variant="contained"
          endIcon={<AddCircleOutline />}
        >
          Add New
        </Button>
      </Stack>
      {loading && <LinearProgress />}
      <Box minHeight={200}>
        <CustomDataGrid
          disableRowSelectionOnClick
          onRowClick={({ row }) => navigate('/meetings/' + row._id)}
          columns={[
            {
              field: 'date',
              headerName: 'Date',
              renderCell: ({ row }) =>
                moment(row.startTime).format('Do MMMM YYYY HH:mm'),
              valueGetter: (value, row) => row.startTime,
              flex: 0.5,
            },
            {
              field: 'type',
              headerName: 'Meeting Type',
              valueGetter: (value, row) => row.meetingType,
              flex: 0.5,
            },
            {
              field: 'attendees',
              headerName: 'Attendees',
              renderCell: ({ row }) => (
                <AvatarGroup max={4}>
                  {row?.[
                    moment() < moment(row.startDate) ? 'invitees' : 'present'
                  ]?.map((person) => (
                    <Tooltip
                      key={person._id}
                      title={`${person.firstName} ${person.lastName}`}
                    >
                      <Avatar
                        src={person.photograph}
                        sx={{ width: 24, height: 24 }}
                      />
                    </Tooltip>
                  ))}
                </AvatarGroup>
              ),
              flex: 1,
            },
            { field: 'location', headerName: 'Location', flex: 1 },
          ]}
          rows={meetings}
          slots={{
            noRowsOverlay: () => (
              <Alert severity="info">
                No meetings recorded yet. Use Add New to log a meeting with its
                agenda, minutes and actions — they're then stored here as a
                governance record.
              </Alert>
            ),
          }}
        />
      </Box>
    </Stack>
  )
}

export default Meetings
